/** @format */

const ConfirmMedicalLetter = () =>
  import("../../../../pages/HRM/medicalLetters/confirmMedicalLetter.vue");

const ViewMedicalLetter = () =>
  import("../../../../pages/HRM/medicalLetters/viewMedicalLetterRequest.vue");

const MedicalLettersDash = () =>
  import("../../../../pages/HRM/medicalLetters/medicalLettersDash.vue");
const AddViewDoctor = () =>
  import("../../../../pages/HRM/medicalLetters/addViewDoctor.vue");

const medicalLettersRoutes = [
  {
    path: "",
    name: "hrm-medicalLettersDashboard",
    component: MedicalLettersDash,
  },
  {
    path: "/view-letter/:letterId",
    name: "viewMedicalLetter",
    component: ViewMedicalLetter,
  },
  {
    path: "/:isMo/confirm-letter/:letterId",
    name: "confirmMedicalLetter",
    component: ConfirmMedicalLetter,
  },
  {
    path: "/view-doctor/:doctorId/:isView",
    name: "viewDoctor",
    component: AddViewDoctor,
  },
];

export default medicalLettersRoutes;
